/*
 * https://bitbucket.org/dnsee/nemo-gui/branch/feature/NEMOGUI-1718 
 * 
 */ 


// export class Redux {
	
// 	const store = createStore(<YOUR REDUCER FUNCTION HERE>)
	
// 	/*The reducer function should handle all possible actions and initialize the app state*/
// 	store.getState() /* Returns current application state */
// 	store.dispatch(<JS object>)
	
// 	/* Dispatch action to change app state. An action is a plain JS object that must have a 'type' key */
// 	store.subscribe(<CALLBACK FUNCTION>) 
// 	/* Will be called after every store.dispatch(), so that we can update our app UI */

// }


import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { actions } from './actions';
import { reduxReducers } from './reducers';
import { mapActionReducers } from './listeners';


@Injectable()
export class Redux {

    private static store: any;
    
    // cambiare in mappe
    // private subscribers: Subscription[];
    private subscribersSubjectMap: any;
    private subscribersStreamMap:  any;
    private callbackByReducer:     Map<string, Function[]>

    constructor() {
        
        this.createStore();

        this.subscribersSubjectMap = {};
        this.subscribersStreamMap =  {};
        this.callbackByReducer = new Map<string, Function[]>();
    }

    createStore(): void {

        // crea lo store in base ai reducers
        Object.keys(reduxReducers).forEach(key => {
            
            Redux.store = {};
            Redux.store[key] = {};
        });
    }

    getStore(): any {
      
        return Redux.store;
    } 

    getState(reducer: string): any {

        if (reducer && Redux.store[reducer])
            return Redux.store[reducer];
                
        return null;
    } 

    dispatch(action: reduxAction): void {

        // Redux.store.dispatch(action);

        if (!actions[action.type])
            return null;

        const reducer = mapActionReducers[action.type];
        
        if (!reducer) return;

        const reducerName = Object.keys(reduxReducers).find(key => reduxReducers[key] === reducer);
        
        if (!reducerName) return;

        // esegui il reducer, passando lo stato iniziale e l'action
        const newState = reducer(this.getState(reducerName), action);
        
        // aggiorna lo store
        Redux.store[reducerName] = newState;
        
        // aggiornare la subscription
        if (this.subscribersSubjectMap[reducerName])    
            this.subscribersSubjectMap[reducerName].next(newState);
        
    } 

    subscribe(reducer: string, callback: Function): Subscription {

        this.subscribersSubjectMap[reducer] = new Subject<any>();
        this.subscribersStreamMap[reducer]  = this.subscribersSubjectMap[reducer].asObservable();


        // TODO
        // bisogna ottimizzare la logica - bisogna togliere il subscribe a redux per i componenti che vengono distrutti
        
        if (!this.callbackByReducer[reducer])
            this.callbackByReducer[reducer] = [];
            
        this.callbackByReducer[reducer].push(callback);

        return this.subscribersStreamMap[reducer].debounceTime(0).subscribe(newState => this.callbackByReducer[reducer].forEach(cb => cb(newState)));
    } 


    unsubscribe(UUID: string) {

        // passare un oggetto custom di Redux (con UUID)

        // memorizzare subscription e callback all'interno di una struttura, con l'UUID
    }
  
}


export interface reduxAction {
    type:    string,
    payload: any
}


// EXAMPLES

// this.reduxService.dispatch({
// 	type:    'SET_BOOKING',
// 	payload: BookingsReservationBookingSectionUtils.serializeToRedux.call(this, resByForm, this.permissionService)
// });


// this.bookingSubscription = this.reduxService.subscribe('authorityReducer', res => {

// 	if (Utilities.isVoidObject(res)) return;

// 	this.booking = res;
// 	this.form.patchValue( BookingReliefReservationDriverUtils.serializeToForm.call(this, res) );

// 	BookingReliefReservationDriverUtils.disableFormByCondition.call(this);
// });
